export class DetailsFromClick {
		public mediaUrl: string = ''
		public hasIdentifier: boolean = false
		public treeHasSpecie: boolean = false
		public treeHasFamily: boolean = false
		public treeHasDap: boolean = false
		public treeHasHeight: boolean = false
		public treeSuppressed: boolean = false;
		public tree?: TreeInformation = new TreeInformation()
		public degreeRisk?: string = ''
		public evaluation?: string
		public evaluator?: string
		public answer?: string
		public color?: string
		public createDate: string
		public identification: number
		public lat?: number
		public lng?: number
		public idMongo?: string
		public appraisalId?: string
		public plantingOpportunityId: string
}

class TreeInformation {
		public identification: number = 0
		public identifierName: string = ''
		public identifier: string = ''
		public height: number = 0
		public specie: string = ''
		public family: string = ''
		public dapCapType: string = ''
		public dapCap: number = 0
		public date: Date
}

export class QuestionsFilters {
		public question: string
		public answers: Array<{
			order: number;
			text: string;
			color: string;
		}>
}

export class FiltersState {
		public checked: boolean
		public order: number
		public text: string
		public color: string
}
